import React, { memo, useState, useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import { TextField } from "@mui/material";

const TasaInteresField = memo(({ clase, valor, onChange }) => {
  const [inputValue, setInputValue] = useState(() => {
    return valor !== undefined ? valor.toString() : "";
  });

  useEffect(() => {
    if (valor !== undefined) {
      setInputValue(valor.toString());
    }
  }, [valor]);

  const handleChange = useCallback(
    (e) => {
      const newValue = e.target.value;

      if (newValue === "" || newValue === ".") {
        setInputValue(newValue);
        return;
      }

      const regex = /^\d*\.?\d{0,1}$/;
      if (regex.test(newValue)) {
        setInputValue(newValue);

        if (newValue !== ".") {
          const numeroFinal = parseFloat(newValue);
          if (!isNaN(numeroFinal)) {
            onChange(clase, "tasaBase", numeroFinal);
          }
        }
      }
    },
    [clase, onChange]
  );

  const handleBlur = useCallback(() => {
    let valorFinal = inputValue;

    if (inputValue !== "") {
      valorFinal = parseFloat(inputValue);
      if (isNaN(valorFinal) || valorFinal < 0) {
        valorFinal = valor;
      }
      setInputValue(valorFinal.toString());
      onChange(clase, "tasaBase", valorFinal);
    }
  }, [inputValue, clase, onChange, valor]);

  return (
    <TextField
      value={inputValue}
      onChange={handleChange}
      onBlur={handleBlur}
      fullWidth
      inputProps={{
        inputMode: "decimal",
        pattern: "\\d*\\.?\\d{0,1}",
        title: "Ingrese un número con máximo un decimal",
      }}
      helperText={
        parseFloat(inputValue) > 0
          ? `Se incluirá un interés del ${inputValue}% en la propuesta`
          : "Tasa de interés mensual"
      }
    />
  );
});

TasaInteresField.propTypes = {
  clase: PropTypes.string.isRequired,
  valor: PropTypes.number,
  onChange: PropTypes.func.isRequired,
};

TasaInteresField.displayName = "TasaInteresField";

export default memo(TasaInteresField);
